import type { SVGProps } from 'react';

export const Pause = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.75 18.5c-.417 0-.775-.142-1.075-.425A1.511 1.511 0 0 1 13.25 17V7c0-.417.142-.767.425-1.05.3-.3.658-.45 1.075-.45H17c.417 0 .767.15 1.05.45.3.283.45.633.45 1.05v10c0 .417-.15.775-.45 1.075A1.426 1.426 0 0 1 17 18.5h-2.25ZM7 18.5c-.417 0-.775-.142-1.075-.425A1.511 1.511 0 0 1 5.5 17V7c0-.417.142-.767.425-1.05.3-.3.658-.45 1.075-.45h2.25c.417 0 .767.15 1.05.45.3.283.45.633.45 1.05v10c0 .417-.15.775-.45 1.075a1.426 1.426 0 0 1-1.05.425H7Zm7.75-1.5H17V7h-2.25v10ZM7 17h2.25V7H7v10ZM7 7v10V7Zm7.75 0v10V7Z" />
    </svg>
  );
};
